<template>
  <div>
    <modal :title="$t('WallFile.validate_zones')" @close-request="$emit('closeModal')" closable>
      <div class="tab">
        <div @click="changeTab('tab1')" :class="{'active-tab' : activeTab === 'tab1'}">
          {{$t('WallFile.groups')}}
        </div>
        <div @click="changeTab('tab2')" :class="{'active-tab' : activeTab === 'tab2'}">
          {{$t('WallFile.zones_by_wallfile')}}</div>
      </div>
      <div v-if="activeTab === 'tab2'">
        <table-element :fields="zoneTableFieldsObj" :arrOfElement="zones" :sortSpacing="0" :isShowFilter="false"
          class="card mx-2 mt-4">

          <template #body-content-desktop="content">
            <!-- List of zones -->
            <tr v-for="(item, index) in content.results" class="table-element_hover text-center" :id="item.id"
              :key="item.zoneName">
              <td> {{ item.zoneName }} </td>
              <td>
                <div class="zones">
                  <div class="zone-names">
                    {{ getZoneNamesString(item.wallFilePickZones) }}
                  </div>
                  <hover-tool-tip
                  :text="getZoneNamesString(item.wallFilePickZones)"
                  :left="true"
                  :clickable="true"
                  />
                </div>
              </td>
              <td>
                <div class="zones">
                  <div class="zone-names">
                    {{ getZoneNamesString(item.wallFileDropZones) }}
                  </div>
                    <hover-tool-tip
                    :text="getZoneNamesString(item.wallFileDropZones)"
                    :left="true"
                    :clickable="true"
                    />
                </div>
              </td>
            </tr>
          </template>


          <template #body-content-mobile="content">
            <!-- List of orders -->
            <transition-group name="fade">
              <div class="card my-3 mx-2" v-for="(item, index) in content.results" :key="item.id">
                <div class="card-header m-2">
                  <h4 style="text-align:center">{{ item.zoneName }}</h4>
                </div>
                <div class="wallfile-pickupzone-card">
                  <h6>Wallfile by pickup Zones:</h6>
                  <div class="df">
                    <p class="clip-text">{{ item.wallFilePickZones.join(", ") || '-' }}</p>
                    <div class="tooltip-div">
                      <hover-tool-tip 
                      :left="true"
                      :text="getZoneNamesString(item.wallFilePickZones || [])"
                      :clickable="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="m-2">
                  <h6>Wallfile by drop Zones:</h6>
                  <div class="df">
                    <p class="clip-text"> {{ item.wallFileDropZones.join(", ") || '-' }}</p>
                    <div class="tooltip-div">
                      <hover-tool-tip 
                      :left="true"
                      :text="getZoneNamesString(item.wallFileDropZones || [])"
                      :clickable="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </template>

        </table-element>
      </div>
      <div v-if="activeTab === 'tab1'">

        <div v-if="showGroupList">
          <table-element :fields="fieldsObj" :arrOfElement="groups" :sortSpacing="0" :isShowFilter="false"
           class="card mx-2 mt-4" :sortable="false" :pageSize="1000" @updateFilterResults="updateFilterResults">
            <template #body-content-desktop="content" >
              <div>test</div>
              <!-- files -->
              <tr v-for="(item) in content.results" :id="item.id" :key="item.name"
              class="table-element_hover text-center draggable-item">
                <td>
                  <div class="item-with-handle">
                    <input @click="editGroup(item)" type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
                      <div style="text-align: center; width: 100%;">{{ item.name }}</div>
                    </div>
                </td>
              </tr>
            </template>
            <template #body-content-mobile="content">
              <!-- files -->
              <div v-for="(item) in content.results" :id="item.id" :key="item.id" class="card p-2  my-3 mx-2 draggable-item">
                <h4 style="text-align: center;">{{ item.name }}</h4>
                <div class="d-flex justify-content-center my-3">
                  <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                </div>
              </div>
            </template>
            <template #post-body-content>
              <div class="mt-2">
                <button @click="addGroup()" class="float-right btn btn-kne-orange m-1">
                  {{$t('WallFile.add_group')}}
                </button>
              </div>
            </template>
          </table-element>
        </div>

        <div v-if="showAddGroup || showEditGroup" style="padding: 20px;">

          <regular-input class="form-group" :value="groupName" @input="groupName = $event"
          :placeholder="$t('WallFile.enter_name')" />

          <multi-select class="zone-select" :options="wallFileOptions" :selected-options="selectedWallFileOptions" @select="handleWallFileSelect"
          :placeholder="$t('WallFile.select_wallfiles')" />

        </div>

        <table-element v-if="showAddGroup || showEditGroup" :fields="wallFileObj" :arrOfElement="wallFiles" :sortSpacing="0" :isShowFilter="false"
          class="card mx-2 mt-4" :isDraggable="true" @updateFinalData="updateFinalData" :pageSize="1000" :sortable="false" :driversSort="true" :groupSort="true">
          <template #body-content-desktop="content" >
            <!-- Wallfiles -->
            <tr v-for="(item) in content.results" :id="item.id" :key="item.name"
            class="table-element_hover text-center draggable-item">
              <td>
                <div class="item-with-handle">
                  <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                  <div class="item-name nowrap" style="position: relative">
                    <span>{{ item.name }}</span>
                    <span ref="hoverIcon" id="hoverIcon" v-if="!checkIconText"
                      class="icon--hover" aria-hidden="true" @mouseenter="e => mouseMoveXY(e.clientX, e.clientY)"
                      @click="onClickCopy(text)">
                      <span class="fa fa-info-circle icon-color icon-background-color"
                        :style="returnIconCSS"></span>
                      <div class="icon--tooltip tooltip-bottom tooltip-left" :style="{ width: getToolTipWidth(item) }" >
                        <i class="text-width" v-html="renderedText(item)" />
                      </div>
                    </span>
                  </div>

                </div>
              </td>
            </tr>
          </template>

          <template #body-content-mobile="content">
            <!-- Wallfiles -->
            <div v-for="(item) in content.results" :id="item.id" :key="item.id" class="card p-2  my-3 mx-2 draggable-item">
              <h4 style="text-align: center;">{{ item.name }}</h4>
              <h6>{{$t('WallFile.pick_zone')}}</h6>
              <div class="df">
                <p class="clip-text">{{item.pickZonesByName ? item.pickZonesByName.join(', ') : 'All'}}</p>
                <div class="tooltip-div">
                  <hover-tool-tip 
                  :left="true"
                  :text="getZoneNamesString(item.pickZonesByName || [])"
                  :clickable="true"
                  />
                </div>
              </div>
              <br>
              <h6>{{$t('WallFile.drop_zone')}}</h6>
              <div class="df">
                <p class="clip-text">{{item.dropZonesByName ? item.dropZonesByName.join(', ') : 'All'}}</p>
                <div class="tooltip-div">
                  <hover-tool-tip 
                  :left="true"
                  :text="getZoneNamesString(item.dropZonesByName || [])"
                  :clickable="true"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-center my-3">
                <i class="mx-2 fa fa-solid fa-bars drag-handle" />
              </div>
            </div>
          </template>

          <template #post-body-content>
            <div class="mt-2">
              <button @click="saveGroup" class="float-right btn btn-kne-orange m-1">
                {{ $t('OrderCurrent.modal.confirm') }}
              </button>
              <button @click="closeGroup()" class="float-right btn btn-danger m-1">{{
                $t('OrderCurrent.modal.cancel') }}</button>
            </div>
          </template>
        </table-element>
      </div>
      <loading-render v-if="isLoading" />
    </modal>
  </div>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import regularSelect from '../../../module/basic-components/regularSelect.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularInputNumber from '../../basic-components/regularInputNumber.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import DistributedHistoryModal from './DistributedHistory-modal.vue'
import DeliveryLocationModal from './DeliveryLocation-modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import LoadingRender from '../Other-components/LoadingRender.vue'
import { MultiSelect } from 'vue-search-select'
import { db } from '../../../../firebase'

export default {
  name: 'ShortDispatchModal',
  components: {
    Modal,
    regularInput,
    regularSelect,
    regularInputNumber,
    regularDatalistDriver,
    hoverToolTip,
    DistributedHistoryModal,
    DeliveryLocationModal,
    TableElement,
    MultiSelect,
    LoadingRender
  },

  props: {
    arrOfWallfile: {
      type: Array,
      required: true
    },
    isOpen: Boolean
  },

  data () {
    return {
      renderWallFiles: false,
      groups: [],
      groupName: '',
      initialGroupName: '',
      groupId: '',
      showGroupList: true,
      showAddGroup: false,
      showEditGroup: false,
      wallFiles: [],
      wallFileOptions: [],
      selectedWallFileOptions: [],
      isFeedbackPlay: false,
      mouseX: 270,
      mouseY: 550,
      zoneTableFieldsObj: [
        {
         text: this.$t('WallFile.zone_name'),
         type: 'zoneName',
         value: ''
       },
       {
        text: this.$t('WallFile.wallfile_by_pick_zones'),
        type: 'wallFileByPickupZone',
        value: ''
       },
       {
         text: this.$t('WallFile.wallfile_by_drop_zones'),
         type: 'wallFileByDropZone',
         value: ''
       }
      ],
      fieldsObj: [
        {
          text: this.$t('WallFile.group_name'),
          type: 'name',
          value: ''
        }
      ],
      wallFileObj: [
        {
          text: this.$t('WallFile.wallfile_name'),
          type: 'name',
          value: ''
        }
      ],
      zones: [],
      adminData: [],
      finalData: this.arrOfWallfile.slice().toReversed() || [],
      activeTab: 'tab1',
      isLoading: true
    }
  },
  async mounted () {
    this.getGroups()
    await this.getZones()
    this.isLoading = false
    this.wallFileOptions = Object.entries(this.arrOfWallfile).map(([id, wf]) => ({
          value: wf.id,
          text: wf.name
      }))
    this.wallFileOptions.sort((a, b) => a.text - b.text)
  },
  methods: {
    getZoneNamesString (zoneNames) {
      if (!zoneNames || !zoneNames.length) return
      return zoneNames.join(', ') || '-'
    },

    mouseMoveXY (x, y) {
      if (!this.displayFixed) return
      this.mouseX = x
      this.mouseY = y
    },

    /** Copy the content of a tooltip to the clipboard if allowed in the props options */
    onClickCopy () {
      if (!this.clickable || !this.text) return
      let fakeText = this.text

      fakeText = this.trimSpaces(fakeText)
      fakeText = this.trimSpecialChars(fakeText)
      navigator.clipboard.writeText(fakeText)
      this.playFeedback()
    },

    /** After calling @function onClickCopy - Show a feedback tooltip and then switch back after a delay */
    playFeedback () {
      this.isFeedbackPlay = true

      setTimeout(() => {
        this.isFeedbackPlay = false
      }, 1000)
    },

    /** Remove unecessary spaces */
    trimSpaces (text) {
      if (!text) return text

      text = text.replace(/ {2}/g, '')
      text = text.trim()

      return text
    },

    /** Remove unecessary characters */
    trimSpecialChars (text) {
      text = text.replace(/<.*>/g, '')

      return text
    },
    renderedText (item) {
      if (this.isFeedbackPlay) return this.$t('hoverToolTip.copied')
      else return this.trimSpaces(this.getToolTipData(item))
    },
    getToolTipWidth (wallFileItem) {
      // minimum tooltop width
      let pickZonesCh = 20
      let dropZonesCh = 20
      // if tooltip has max width then make it wrap the text
      if (wallFileItem.pickZonesByName) {
        pickZonesCh = wallFileItem.pickZonesByName.join(', ').length
        if (pickZonesCh > 90) {
          return '37vw'
        }
      }
      if (wallFileItem.dropZonesByName) {
        dropZonesCh = wallFileItem.dropZonesByName.join(', ').length
        if (dropZonesCh > 90) {
          return '37vw'
        }
      }
      // else choose width based on the number of characters
      if (pickZonesCh > dropZonesCh) {
        return `${(pickZonesCh + 2) * 2}ch`
      }
      return `${(dropZonesCh + 2) * 2}ch`
    },
    getToolTipData (wallFileItem) {
      let text = ''
      text += `<div"><strong>${this.$t('WallFile.pick_zone')}:</strong></div>`
      text += wallFileItem.pickZonesByName ? `<p>${wallFileItem.pickZonesByName.join(', ') || '-'}</p>` : '<p>All</p>'
      text += `<br>`
      text += `<div"><strong>${this.$t('WallFile.drop_zone')}:</strong></div>`
      text += wallFileItem.dropZonesByName ? `<p>${wallFileItem.dropZonesByName.join(', ') || '-'}</p>` : '<p>All</p>'
      return text
    },
    async getZones () {
      // Use zones from store
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      const storeZones = this.$store.state.zones
      if (storeZones.length) {
        this.zones = storeZones.map(zone => {
          const id = zone.id
          const zoneName = zone.zoneName
          const wallFilePickZones = []
          const wallFileDropZones = []
          this.arrOfWallfile.forEach(wallFileItem => {
            if (wallFileItem.pickZones && wallFileItem.pickZones.includes(id)) {
              wallFilePickZones.push(wallFileItem.name)
            }
          })
          this.arrOfWallfile.forEach(wallFileItem => {
            if (wallFileItem.dropZones && wallFileItem.dropZones.includes(id)) {
              wallFileDropZones.push(wallFileItem.name)
            }
          })
          return {
            id,
            zoneName,
            wallFilePickZones,
            wallFileDropZones
          }
        })
      } else {
        this.zones = []
      }
      return Promise.resolve()
    },
    changeTab (value) {
      this.activeTab = value
      this.showGroupList = true
      this.showAddGroup = false
      this.showEditGroup = false
      this.$forceUpdate()
    },
    saveGroup () {
      if (!this.groupName) {
        confirm('Please enter group name')
        return
      }
      if (!this.selectedWallFileOptions || !this.selectedWallFileOptions.length) {
        confirm('Please select wallfiles')
        return
      }
      if (this.showEditGroup && this.groupName !== this.initialGroupName && this.sameGroupName(this.groupName)) {
          console.log({initial: this.initialGroupName})
          confirm('Group Name already exists')
          return
      }
      if (!this.showEditGroup && this.sameGroupName(this.groupName)) {
          confirm('Group Name already exists')
          return
      }
      this.finalData.forEach((item, index) => {
        item.index = (index + 1000)
      })
      const newData = this.finalData
      let obj = {}
      newData.forEach(e => {
        obj[e.id] = e.index
      })
      if (this.showEditGroup) {
        this.updateGroup(obj)
        return
      }
      this.createGroup(obj)
    },
    closeGroup () {
      this.showAddGroup = false
      this.showEditGroup = false
      this.showGroupList = true
    },

    sameGroupName () {
      return this.groups.some(group => group.name === this.groupName)
    },
    createGroup (obj) {
      db.ref('database/groups/transporter').child(this.companyUID).child('group').push().set(
        {
          name: this.groupName,
          wallFiles: obj
        }
      ).then(() => {
        console.log('Group saved')
        this.groupName = ''
        this.wallFiles = []
        this.selectedWallFileOptions = []
        this.$emit('closeModal')
      }).catch(function (error) {
        confirm('Error adding wall file')
        console.error(error)
      })
    },
    updateGroup (obj) {
      db.ref('database/groups/transporter').child(this.companyUID).child('group').child(this.groupId).update(
        {
          name: this.groupName,
          wallFiles: obj
        }
      ).then(() => {
        console.log('Group updated')
        this.groupName = ''
        this.wallFiles = []
        this.selectedWallFileOptions = []
        this.$emit('closeModal')
      }).catch(function (error) {
        confirm('Error adding wall file')
        console.error(error)
      })
    },
    getGroups () {
      db.ref('database/groups/transporter').child(this.companyUID).child('group').once('value', (snapshot) => {
        if (!snapshot.exists()) {
          this.groups = []
          return
        }
        this.groups = Object.entries(snapshot.val()).map(([id, zoneData]) => ({
              id,
              ...zoneData
        }))
        this.$forceUpdate()
      })
    },
    deleteAllGroups () {
      db.ref('database/groups/transporter').child(this.companyUID).child('group').remove()
        .then(() => {
          console.log('Groups deleted')
          this.closeModal()
        })
        .catch(error => {
          confirm('Error deleting groups')
          console.error('Error deleting group from firebase:', error)
        })
    },
    updateFinalData (newData) {
      this.finalData = newData
    },
    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },
    async saveAllData (newData) {
      // create a bulk update object
      const updates = {}
      for (const item of newData) {
        const itemCopy = { ...item }
        const path = `database/wallfiles/transporter/${this.companyUID}/wallfile/${itemCopy.id}/index`
        updates[path] = itemCopy.index
      }
      try {
        await db.ref().update(updates)
        console.log('Default order update successful')
        this.closeModal()
      } catch (error) {
        console.error('Error updating default order:', error)
      }
    },
    handleWallFileSelect: function (list) {
      this.selectedWallFileOptions = list
      if (this.wallFiles.length > list.length) { // remove
        let arr = [...this.wallFiles]
        arr.forEach(wf => {
          let wfs = list.filter(e => e.text === wf.name)
          if (!wfs.length) {
            this.wallFiles = this.wallFiles.filter(e => e.id !== wf.id)
          }
        })
      } else { // add
        let wfs = this.arrOfWallfile.filter(wf => wf.name === list[this.wallFiles.length].text)
        wfs[0].index = 1000 + this.wallFiles.length
        this.wallFiles.push(wfs[0])
      }
      this.finalData = this.wallFiles
    },
    editGroup (group) {
      this.showGroupList = false
      this.showAddGroup = false
      this.wallFiles = this.arrOfWallfile.filter(wf => group.wallFiles[wf.id])
      this.wallFiles.forEach(wf => {
        wf.index = group.wallFiles[wf.id]
      })
      this.groupName = group.name
      this.initialGroupName = group.name
      this.groupId = group.id
      this.selectedWallFileOptions = this.wallFileOptions.filter(o => this.wallFiles.find(wf => wf.name === o.text))
      this.finalData = this.wallFiles
      this.wallFiles.sort((a, b) => a.index - b.index)
      this.showEditGroup = true
    },
    addGroup () {
      this.showGroupList = false
      this.showEditGroup = false
      this.showAddGroup = true
      this.groupName = ''
      this.wallFiles = []
      this.finalData = []
      this.selectedWallFileOptions = []
    },
    closeModal () {
      this.$emit('closeModal')
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    },
    checkIconText () {
      if (this.iconText === false || this.iconText === '' || typeof this.iconText === 'undefined') return false
      else return true
    },

    returnIconCSS () {
      return {
        '--icon-color': this.iconColor,
        '--icon-background-color': this.iconBackgroundColor
      }
    },
    returnToolTipPosition () {
      return {
        'position': 'fixed',
        'top': (this.mouseY) + 'px',
        'left': (this.mouseX) + 'px'
      }
    }
  }
}
</script>

<style scoped>
   .tab{
    display:flex;
    gap:2rem;
    padding-inline:.75rem;
    padding-top:.75rem;
    color:grey;
   }
   .tab>div{
    cursor: pointer;
    width:50%;
    line-height: 2rem;
    text-align: center;
   }
   .tab>div:last-child{
     padding-bottom:.25rem;
     border-left:2px solid rgba(223, 217, 217, 0.527);
    }
    .active-tab{
      font-weight: bold;
      color:black;
   }
   .modal-container{
     display: flex;
     gap:1rem;
    }
  
   .item-with-handle{
    display: flex;
   }
   .item-name{
    margin-inline:auto;
   }
   .wallfile-pickupzone-card{
    margin: 0.5rem 0.5rem 0 0.5rem;
    border-bottom:1px solid #F0F0F0; 
    padding-bottom:.125rem;
   }

  .icon--hover {
    color: #f7941e;
    position: relative;
    text-align: center;
  }

  .icon--hover .icon--tooltip {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8rem;
    background: #e88b1a;
    border-radius: 3px;
    color: white;
    margin-bottom: 10px;
    opacity: 0;
    padding: 8px;
    pointer-events: none;
    text-wrap: wrap;
    -webkit-transform: translateY(10px);
    -moz-transform: translateY(10px);
    -ms-transform: translateY(10px);
    -o-transform: translateY(10px);
    transform: translateY(10px);
    -webkit-transition: all .25s ease-out;
    -moz-transition: all .25s ease-out;
    -ms-transition: all .25s ease-out;
    -o-transition: all .25s ease-out;
    transition: all .25s ease-out;
    -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  }
  .icon--tooltip {
    position: absolute;
    z-index: 999999;
  }
  
  .tooltip-bottom {
    top: 80%;
  }
  .tooltip-left {
    left: 0%;
  }

  .strong {
    font-weight: 900;
  }
  .icon--hover:hover .icon--tooltip {
    opacity: 1;
    pointer-events: auto;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  .background-thing {
    font-size: 0.8rem;
    background-color: rgb(255, 255, 255);
    border-radius: 5rem;
    padding: 0.25rem 0.25rem 0.25rem 0.25rem;
  }

  .icon-color {
    color: var(--icon-color);
  }

  .icon-background-color {
    background-color: var(--icon-background-color)
  }
  .zones {
    width: 30vw !important;
    display: flex;
    flex-wrap: nowrap
  }
  .zone-names {
    width: 95%;
    overflow: hidden; 
    white-space: nowrap; 
    text-overflow: ellipsis;
  }
  .zones {
    width: 30%;
  }
  .df {
    display: flex;
    flex-wrap: nowrap;
  }
  .clip-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  } 
  .tooltip-div {
    margin-left: auto;
  }
</style>
